<template>
    <v-card-subtitle class="text-h7 my-0 py-0">
        <v-row no-gutters>
            <v-col class="col-auto mr-2">
                <span class="d-inline-block">{{ $t('purposes.published') +": " }}</span>
            </v-col>
            <v-col
                v-if="purpose"
                class="col-auto"
            >
                <span v-if="purpose.attributes && purpose.attributes['created-at']">
                    {{ dateHelper.getDateTimeTableFormat(purpose.attributes['created-at']) }}
                </span>
                <div
                    v-else
                    :inner-html.prop="dateHelper.getDateTimeToFormatAndLocale(purpose.created_at) | highlight(search)"
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="col-auto mr-2">
                <span class="d-inline-block">{{ $t('admin.common.updatedAt') +": " }}</span>
            </v-col>
            <v-col
                v-if="purpose"
                class="col-auto"
            >
                <span v-if="purpose.attributes && purpose.attributes['created-at']">{{ dateHelper.getDateTimeTableFormat(purpose.attributes['updated-at']) }}</span>
                <div
                    v-else
                    :inner-html.prop="dateHelper.getDateTimeToFormatAndLocale(purpose.updated_at) | highlight(search)"
                />
            </v-col>
        </v-row>
    </v-card-subtitle>
</template>

<script>
export default {
    name: 'PurposeDate',
    props: {
        purpose: {
            type: Object,
            default() {
                return null;
            }
        },
        search: {
            type: String,
            default: '',
            required: false
        }
    }
}
</script>

<style scoped>

</style>
